import { SEARCH_PARAMS, getCorrectedURLSearchParams } from '@novakid/frontend-core';
import { Navigate, useLocation } from 'react-router-dom';
import { useContext, FC } from 'react';

import { UserContext } from 'contexts';

type Props = Record<string, unknown>;

const getEnrichedSearchParams = (search: string, pathname: string) => {
  const searchParams = getCorrectedURLSearchParams(search);

  const hasReturnPath = searchParams.has(SEARCH_PARAMS.RETURN_PATH);
  const hasReturnUrl = searchParams.has(SEARCH_PARAMS.RETURN_URL);

  if (!hasReturnPath && !hasReturnUrl && pathname !== '/') {
    searchParams.set(SEARCH_PARAMS.RETURN_PATH, pathname);
  }

  return searchParams.toString();
}

export const withAuthorization = <T extends Props>(Component: FC) => (props: T) => {
  const { pathname, search } = useLocation();
  const user = useContext(UserContext);

  if (!user) {
    return (
      <Navigate
        to={{ pathname: '/signin', search: getEnrichedSearchParams(search, pathname) }}
        replace
      />
    );
  }

  return <Component {...props} />;
}